/* __next_internal_client_entry_do_not_use__ primaryDestructiveStyle,secondaryDestructiveStyle,tertiaryDestructiveStyle,buttonTheme,buttonEventsTheme auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { Core, Decorative } from "@faire/design-tokens";
import Color from "../Color";
import { eventsThemeColors, getEventTheme } from "../Theme/eventsThemeColors";
var REGULAR_BUTTON_HEIGHT = 48;
var SMALL_BUTTON_HEIGHT = 40;
var calculateButtonHeight = function(small) {
    return "".concat(small ? SMALL_BUTTON_HEIGHT : REGULAR_BUTTON_HEIGHT, "px");
};
export var primaryDestructiveStyle = {
    base: {
        color: Core.text.critical,
        "background-color": Core.surface.critical,
        border: "1px solid ".concat(Core.surface.critical)
    },
    loading: {
        color: Core.icon.critical,
        "background-color": Core.surface.critical,
        border: "1px solid ".concat(Core.surface.critical)
    },
    hover: {
        color: Core.text.inverse,
        "background-color": Color.siren,
        border: "1px solid ".concat(Color.siren)
    },
    disabled: {
        color: Core.text.disabled,
        "background-color": Core.surface.disabled,
        border: "1px solid ".concat(Core.border.disabled)
    },
    active: {
        color: Core.text.inverse,
        "background-color": Color.siren,
        border: "1px solid ".concat(Color.siren)
    },
    focus: {
        color: Core.text.critical
    }
};
export var secondaryDestructiveStyle = {
    base: {
        color: Core.text.critical,
        "background-color": Core.surface.inverse,
        border: "1px solid ".concat(Core.border.critical)
    },
    loading: {
        color: Core.icon.critical,
        "background-color": Core.surface.inverse,
        border: "1px solid ".concat(Core.border.critical)
    },
    hover: {
        color: Core.text.critical,
        "background-color": Core.surface.critical,
        border: "1px solid ".concat(Core.border.critical)
    },
    disabled: {
        color: Core.text.disabled,
        "background-color": Core.surface.inverse,
        border: "1px solid ".concat(Core.border.disabled)
    },
    active: {
        color: Core.text.critical,
        "background-color": Core.surface.critical,
        border: "1px solid ".concat(Core.border.critical)
    }
};
export var tertiaryDestructiveStyle = {
    base: {
        color: Core.text.critical,
        "text-decoration-color": Core.text.critical
    },
    loading: {
        color: Core.icon.critical
    },
    hover: {
        color: Decorative.shade.red,
        "text-decoration-color": Decorative.shade.red
    },
    disabled: {
        color: Core.text.disabled,
        "text-decoration-color": Core.text.disabled
    },
    active: {
        color: Decorative.shade.red,
        "text-decoration-color": Decorative.shade.red
    },
    focus: {
        color: Core.text.critical,
        "text-decoration-color": Core.text.critical
    }
};
var primaryStyle = {
    base: function(param) {
        var $small = param.$small, $destructive = param.$destructive;
        return _object_spread({
            height: calculateButtonHeight($small),
            padding: "0 23px",
            border: "1px solid ".concat(Core.border.default),
            "background-color": Core.surface.default,
            color: Core.text.inverse
        }, $destructive ? primaryDestructiveStyle.base : {});
    },
    loading: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            "background-color": Core.surface.enabled,
            color: Core.text.inverse,
            "border-color": Core.surface.enabled
        }, $destructive ? primaryDestructiveStyle.loading : {});
    },
    hover: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            "background-color": Core.surface.hover,
            "border-color": Core.border.hover,
            color: Core.text.inverse
        }, $destructive ? primaryDestructiveStyle.hover : {});
    },
    disabled: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            "background-color": Core.surface.disabled,
            "border-color": Core.border.disabled,
            color: Core.text.disabled
        }, $destructive ? primaryDestructiveStyle.disabled : {});
    },
    active: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            color: Core.text.inverse
        }, $destructive ? primaryDestructiveStyle.active : {});
    },
    focus: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            color: Core.text.inverse
        }, $destructive ? primaryDestructiveStyle.focus : {});
    }
};
var secondaryStyle = {
    base: function(param) {
        var $small = param.$small, $destructive = param.$destructive;
        return _object_spread({
            height: calculateButtonHeight($small),
            padding: "0 23px",
            border: "1px solid ".concat(Core.border.default),
            "background-color": Core.surface.inverse,
            color: Core.text.default
        }, $destructive ? secondaryDestructiveStyle.base : {});
    },
    loading: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            color: Core.text.default
        }, $destructive ? secondaryDestructiveStyle.loading : {});
    },
    hover: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            "background-color": Core.surface.hover,
            color: Core.text.inverse
        }, $destructive ? secondaryDestructiveStyle.hover : {});
    },
    disabled: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            color: Core.text.disabled,
            "background-color": Core.surface.inverse,
            border: "1px solid ".concat(Core.border.subdued)
        }, $destructive ? secondaryDestructiveStyle.disabled : {});
    },
    active: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({}, $destructive ? secondaryDestructiveStyle.active : {});
    }
};
var tertiaryStyle = {
    base: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            display: "inline-flex",
            "background-color": "transparent",
            "text-decoration": "underline",
            "text-decoration-color": Core.text.default,
            color: Core.text.default
        }, $destructive ? tertiaryDestructiveStyle.base : {});
    },
    loading: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            color: Core.icon.default
        }, $destructive ? tertiaryDestructiveStyle.loading : {});
    },
    hover: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            color: Core.text.hover,
            "text-decoration": "underline",
            "text-decoration-color": Core.text.hover
        }, $destructive ? tertiaryDestructiveStyle.hover : {});
    },
    disabled: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            color: Core.text.disabled,
            "text-decoration-color": Core.text.disabled
        }, $destructive ? tertiaryDestructiveStyle.disabled : {});
    },
    active: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({}, $destructive ? tertiaryDestructiveStyle.active : {});
    },
    focus: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            "text-decoration": "underline",
            "text-decoration-color": Core.text.default
        }, $destructive ? tertiaryDestructiveStyle.focus : {});
    }
};
export var buttonTheme = {
    primary: primaryStyle,
    secondary: secondaryStyle,
    tertiary: tertiaryStyle
};
var primaryStyleEventsTheme = _object_spread_props(_object_spread({}, buttonTheme.primary), {
    base: function(param) {
        var $small = param.$small, $destructive = param.$destructive;
        return _object_spread({
            height: calculateButtonHeight($small),
            padding: "0 23px",
            "background-color": getEventTheme("faireMarket").primaryDark,
            color: getEventTheme("faireMarket").promoTextInverse
        }, $destructive ? primaryDestructiveStyle.base : {});
    }
});
var secondaryStyleEventsTheme = _object_spread_props(_object_spread({}, buttonTheme.secondary), {
    base: function(param) {
        var $small = param.$small, $destructive = param.$destructive;
        return _object_spread({
            height: calculateButtonHeight($small),
            padding: "0 23px",
            border: "unset",
            color: getEventTheme("faireMarket").promoText,
            "background-color": Core.surface.inverse
        }, $destructive ? secondaryDestructiveStyle.base : {});
    }
});
var tertiaryStyleEventsTheme = {
    base: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            display: "inline-flex",
            "background-color": "transparent",
            "text-decoration": "underline",
            "text-decoration-color": eventsThemeColors.faireMarket.primaryDark,
            color: eventsThemeColors.faireMarket.primaryDark
        }, $destructive ? tertiaryDestructiveStyle.base : {});
    },
    loading: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            color: Core.text.inverse
        }, $destructive ? tertiaryDestructiveStyle.loading : {});
    },
    hover: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            color: "#5262C7",
            "text-decoration": "underline",
            "text-decoration-color": "#5262C7"
        }, $destructive ? tertiaryDestructiveStyle.hover : {});
    },
    disabled: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            color: Core.text.disabled,
            "text-decoration-color": Core.surface.disabled
        }, $destructive ? tertiaryDestructiveStyle.disabled : {});
    },
    active: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            color: eventsThemeColors.faireMarket.primaryDark,
            "text-decoration-color": eventsThemeColors.faireMarket.primaryDark
        }, $destructive ? tertiaryDestructiveStyle.active : {});
    },
    focus: function(param) {
        var $destructive = param.$destructive;
        return _object_spread({
            "text-decoration": "underline",
            "text-decoration-color": eventsThemeColors.faireMarket.primaryDark
        }, $destructive ? tertiaryDestructiveStyle.focus : {});
    }
};
export var buttonEventsTheme = {
    primary: primaryStyleEventsTheme,
    secondary: secondaryStyleEventsTheme,
    tertiary: tertiaryStyleEventsTheme
};
